import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledBoxProps {
  layoutHeight?: number;
}

const StyledBox = styled(Box)<StyledBoxProps>(({ theme, layoutHeight }) => ({
  '& .GVContainer': {
    marginTop: theme.spacing(9),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down('xl')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },

  '& .GVPaginationContiner': {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  '& .GVPageTitleContainer': {
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(10),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(layoutHeight ?? 0),
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
      justifyContent: 'space-between',
    },
  },

  '& .GVMapSide': {
    position: 'sticky',
    right: 0,
    top: theme.spacing(layoutHeight ?? 0),
    height: `calc(100vh - ${theme.spacing(layoutHeight ?? 0)})`,
  },
  '& .GVHideAndShowMapBtn': {
    transition: 'transform 0.3s ease-in-out',
    minWidth: 'unset',
    padding: theme.spacing(1.875, 2),
    backgroundColor: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.overlay[1]}`,
    backdropFilter: 'blur(8px)',
    position: 'relative',
    top: theme.spacing(4),
    '&:hover, &:active, &:focus': {
      boxShadow: 'none',
    },
    '& .GVIconBtn': {
      fontSize: theme.spacing(2),
    },
    '&.GVShowMapBtn': {
      transform: `translateX(${theme.spacing(12)})`,
      '& .GVIconBtn': {
        transform: 'rotate(180deg)',
      },
    },
  },
  '& .GVESPromoContainer': {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    borderTop: `1px solid ${theme.palette.divider[6]}`,
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
    },
  },
  '& .GVLinksGroupsContiner': {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    backgroundColor: theme.palette.background.secondary,
  },
}));

export default StyledBox;
